import { Drawer } from '@mui/material';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Variables } from '../base';
import * as S from './sidebar.styles';

export interface ISidebarProps {
    className?: string;
    noMobile?: boolean;
    visible?: boolean;
    /**
     * When not visible, shrink to an icon rail (`Variables.sidebarRailSize`) instead of hiding.
     */
    rail?: boolean;
    onClose: () => void;
    children?: React.ReactNode;
}

export const Sidebar: React.FC<ISidebarProps> = props => {
    const { className, children, noMobile, visible, rail, onClose } = props;
    const isMobile = useIsMobile();
    const width = rail && !visible ? Variables.sidebarRailSize : Variables.sidebarSize;

    const location = useLocation();

    React.useEffect(() => {
        if (!isMobile) {
            return;
        }

        onClose();
    }, [location]);

    return (
        <Drawer
            sx={{
                width,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width,
                    boxSizing: 'border-box',
                    ...(rail && { overflowX: 'hidden' }),
                    transition: 'width 225ms cubic-bezier(0, 0, 0.2, 1) 0ms',
                },
            }}
            variant="persistent"
            anchor="left"
            open={visible || rail}>
            <S.Sidebar visible={visible} rail={rail} noMobile={noMobile} className={className}>
                {children}
            </S.Sidebar>
        </Drawer>
    );
};

const useIsMobile = () => {
    const [width, setWidth] = React.useState<number>(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    React.useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return isMobile;
};
